"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Table;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
require("./Table.css");
var _excluded = ["contents"];
function Table(_ref) {
  var _props$style$vertical, _props$style;
  var contents = _ref.contents,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var verticalAlignment = (_props$style$vertical = (_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.verticalAlign) !== null && _props$style$vertical !== void 0 ? _props$style$vertical : "middle";
  return /*#__PURE__*/_react.default.createElement("table", {
    className: "bdg-table"
  }, /*#__PURE__*/_react.default.createElement("tbody", null, contents.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement("tr", null, value.map(function (v, i) {
      if (v.isHeader) {
        return /*#__PURE__*/_react.default.createElement("th", {
          style: (0, _objectSpread2.default)({
            verticalAlign: verticalAlignment
          }, props.style),
          colSpan: v.colSpan,
          scope: v.colSpan ? 'colgroup' : undefined,
          tabIndex: "0"
        }, v.data);
      } else {
        return /*#__PURE__*/_react.default.createElement("td", {
          style: (0, _objectSpread2.default)({
            verticalAlign: verticalAlignment
          }, props.style),
          tabIndex: "0"
        }, v.data);
      }
    }));
  })));
}